import type { FaireProductEntity } from "../../entity_types/product";

export const p_eyf4qfnjhx: FaireProductEntity = {
  token: "p_eyf4qfnjhx",
  type: "product",
  name: "Seven Fishes Tea Towel - Gumdrop",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/cd526348359cc2b7204d6811336a64750473ea07a06b0eb2518851a97382ce4c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b0955968fabf86545cdb04e4969844df630f593153e4b96c7238e514b72504ed.jpeg",
    "https://cdn.faire.com/fastly/0da0b9078452cdf1affd9a87fcdd88d029ab20249df5b012ad79381644cf9535.jpeg",
    "https://cdn.faire.com/fastly/656a11aa3296c126dfbe68399f8d37881f1c5c56b616f93cf802026fc6f2f8e2.jpeg",
    "https://cdn.faire.com/fastly/09aa1c66d306eaf0b7e39a2d80af98a41fd693130937c91d741308cb642c3c08.jpeg"
  ],
  priceDollars: 11,
  description: "A traditional flour sack tea towel great for food wrapping, and kitchen decor. \n\nGood to know:\n\n * Screenprinted in the USA with plant based ink. \n * Measures 20in x 20in \n * 100% organic cotton ",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:10.433Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
